import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { unregister } from './registerServiceWorker';
import App from './App';
import store from './redux/store';
import DocumentTitle from 'react-document-title';
import AppTheme from './components/theme/AppTheme';

ReactDOM.render(
  <Provider store={store}>
    <DocumentTitle title="Inflo - Screenless Productivity">
      <AppTheme>
        <App />
      </AppTheme>
    </DocumentTitle>
  </Provider>,
  document.getElementById('root')
);
unregister();
